import { useMsal } from "@azure/msal-react";

const LandingPage = () => {
  const { instance } = useMsal();
  const account = instance.getAllAccounts()[0];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",   // vertical centering
        alignItems: "center",       // horizontal centering
        height: "20vh",            // full viewport height
        width: "100vw",             // full viewport width
      }}
    >
      {account ? (
        <>
          <h1>Welcome to the BOOM Portal</h1>
          <p>Select an item from the menu to get started.</p>
        </>
      ) : (
        <p style={{ fontSize: "18px", fontWeight: "500" }}>
          Sign in to continue
        </p>
      )}
    </div>
  );
};

export default LandingPage;
